import { render, staticRenderFns } from "./ComplaintsModule.vue?vue&type=template&id=2cc0f02c&scoped=true&"
import script from "./ComplaintsModule.vue?vue&type=script&lang=js&"
export * from "./ComplaintsModule.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsModule.vue?vue&type=style&index=0&id=2cc0f02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0f02c",
  null
  
)

export default component.exports